import { useMemo } from "react";
import { usePlan } from "../contexts/PlanContext";
import {
  permissionCategories,
  distributorPermissionCategory,
  ADVANCED_DISTRIBUTOR_PERMISSION,
  TOTAL_PERMISSIONS,
  ALL_PERMISSION_KEYS,
} from "../data/permissionCategories";

/**
 * The admin permission groups THIS institute can grant.
 *
 * Identical to the static list everywhere — same array, same totals — except at
 * an institute the SaaS admin has made a distributor, which also gets the
 * Distributor group. Reading the list through here is what keeps every other
 * institute's "12 of 40 granted" exactly as it was.
 */
export default function usePermissionCategories() {
  const { distributor } = usePlan();
  return useMemo(() => {
    if (!distributor) {
      return { categories: permissionCategories, total: TOTAL_PERMISSIONS, allKeys: ALL_PERMISSION_KEYS };
    }
    // "Create & Open Institutes" exists only where advanced distribution is on,
    // so an ordinary distributor's group and totals are what they were.
    const group = distributor.advanced
      ? distributorPermissionCategory
      : {
        ...distributorPermissionCategory,
        permissions: distributorPermissionCategory.permissions.filter((p) => p.key !== ADVANCED_DISTRIBUTOR_PERMISSION),
      };
    const categories = [...permissionCategories, group];
    const extraKeys = group.permissions.map((p) => p.key);
    return {
      categories,
      total: TOTAL_PERMISSIONS + extraKeys.length,
      allKeys: [...ALL_PERMISSION_KEYS, ...extraKeys],
    };
  }, [distributor]);
}
